enum ctaTypes {
  primaryRed = 'p-red',
  primaryWhite = 'p-white',
  primaryBlack = 'p-black',
  secondaryRed = 's-red',
  secondaryWhite = 's-white',
  baseButton = 'cta',
  secondaryBaseButton = 'button',
  smallButton = 'cta--small',
}

export default ctaTypes;
